<div class="container">
    <div class="collection">
        <div class="item" *ngFor="let item of items">
            <app-team-card-photo [isTeamCard]="isTeamList" [item]="item" [gradientClass]="'red'" (redirectToDetail)="redirectToDetail.emit($event)"></app-team-card-photo>
        </div>
    </div>
    <div class="pagination" *ngIf="isPagination">
        <p-paginator [rows]="10" #paginator  [totalRecords]="totalSize" (onPageChange)="changePage.emit($event)"></p-paginator>
    </div>
</div>
